

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useNavigate } from "react-router-dom";


// const BASE_URL = "https://ecom.cyberathon.com/";

// const Ebooks = () => {
//   const navigate = useNavigate();
//   const [pdfs, setPdfs] = useState([]);

//   useEffect(() => {
//     axios
//       .get("https://ecom.cyberathon.com/index.php/Api/list_pdf")
//       .then((res) => {
//         if (res.data.status) {
//           setPdfs(res.data.data);
//         }
//       })
//       .catch((err) => console.error(err));
//   }, []);

// //   const handlePurchase = async (pdf_id) =>{
// //     try{
// // const res = await axios.post(
// //   "https://ecom.cyberathon.com/index.php/Api/get_add_to_cart_by_id",
// //   {
// //     prod_id:pdf_id,
// //   }
// // );
// // console.log(res.data);
// //       if(res.data.status){
// //         alert("Product added to cart!");
// //       }else{
// //         alert("Already added or failed");
// //       }
// //     }catch(error){
// //       console.error("Error",error);
// //     }
// //   }

// // const handlePurchase = async (prod_id) => {

// //   // 1. prod_id check karo — kuch purane PDFs mein null hai
// //   if (!prod_id) {
// //     alert("This item is not available for purchase yet.");
// //     return;
// //   }

// //   // 2. User logged in hai ya nahi
// //   const userId = sessionStorage.getItem("userId");
// //   if (!userId) {
// //     alert("Please login first!");
// //     navigate("/login"); // agar alag route hai toh woh likhna
// //     return;
// //   }

// //   // 3. API call
// //   try {
// //     const res = await axios.post(
// //       // "https://ecom.cyberathon.com/index.php/Api/get_add_to_cart_by_id",
// //       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
// //       {
// //         prod_id: Number(prod_id),
// //         user_id: Number(userId),
// //         qty: 1
// //       }
// //     );

// //     console.log("Cart response:", res.data);

// //     if (res.data.status === true) {
// //       setTimeout(() => navigate("/functioncart"), 800); // apna cart route
// //     } else {
// //       alert(res.data.message || "Failed to add to cart");
// //     }
// //   } catch (error) {
// //     console.error("Error", error);
// //     alert("Something went wrong");
// //   }
// // };
// const handlePurchase = async (prod_id) => {
//   if (!prod_id) {
//     alert("This item is not available for purchase yet.");
//     return;
//   }

//   const userId = sessionStorage.getItem("userId");

//   if (!userId) {
//     alert("Please login first!");
//     navigate("/login");
//     return;
//   }

//   try {
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       {
//         user_id: Number(userId),
//         prod_id: Number(prod_id),
//         qty: 1
//       }
//     );

//     console.log("✅ Cart response:", res.data);

//     if (res.data.status === true) {
//       alert("Added to cart!");
//       navigate("/functioncart");
//     } else {
//       alert(res.data.message || "Failed");
//     }
//   } catch (error) {
//     console.error(error);
//     alert("Error");
//   }
// };
//   return (
//     <>
//     <Layout/>
//     <div className="pdf-page">
//       <h2 className="page-title mb-5 fw-bold fs-2">E-Books</h2>

//       <div className="pdf-grid">
//         {pdfs.map((item) => (
//           <div className="pdf-box" key={item.pdf_id}>
//             {/* PDF COVER */}
//             <iframe
//               src={`${BASE_URL}${item.pdf}#page=1&view=FitH&toolbar=0&navpanes=0`}
//               title={item.name}
//               className="pdf-cover"
//             />

//             <div className="pdf-info">
//               <h3>{item.name}</h3>
//               <p>{item.description}</p>
//               <p>{item.details}</p>
//               <p>{item.current_price}</p>
//               <p>{item.old_price}</p>
//               <a
//                 href={`${BASE_URL}${item.pdf}`}
//                 target="_blank"
//                 rel="noreferrer"
//               ><button className="bg-col text-light border-0 rounded-1">
//                 Open PDF</button>
//               </a>
//               <button
//               className="bg-dark text-light border-0 rounded-1 ms-2"
//               onClick={()=> handlePurchase(item.prod_id)}
//                disabled={!item.prod_id}  // ← null hai toh disabled
//   style={{ opacity: item.prod_id ? 1 : 0.5, cursor: item.prod_id ? "pointer" : "not-allowed" }}
// >
//   {item.prod_id ? "Purchase" : "Unavailable"}
// </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//     <FooterNew/>
//     </>
//   );
// };

// export default Ebooks;

// Before checked purchase on 18 march 
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../Context/CartContext";

// const BASE_URL = "https://ecom.cyberathon.com";

// const Ebooks = () => {
//   const navigate = useNavigate();
//   const { setCartCount } = useCart();

//   const [pdfs, setPdfs] = useState([]);
//   const [addedItems, setAddedItems] = useState([]); // prod_ids already in cart
//   const [loadingItem, setLoadingItem] = useState(null);

//   // ── Fetch PDFs ──
//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/index.php/Api/list_pdf`)
//       .then((res) => {
//         if (res.data.status) setPdfs(res.data.data);
//       })
//       .catch((err) => console.error(err));
//   }, []);

//   // ── Load already added cart items ──
//   useEffect(() => {
//     const loadCartItems = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const cartToken = localStorage.getItem("cart_token");
//       if (!userId && !cartToken) return;

//       try {
//         const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//           user_id: userId || null,
//           cart_token: userId ? null : cartToken,
//         });
//         if (res.data.status) {
//           const ids = res.data.cart_items.map((item) => String(item.prod_id));
//           setAddedItems(ids);
//         }
//       } catch (err) {
//         console.error("Cart load error:", err);
//       }
//     };

//     loadCartItems();
//   }, []);

//   // ── Add to Cart (no redirect — just toggle) ──
//   const handleAddToCart = async (prod_id) => {
//     if (!prod_id) {
//       alert("This item is not available for purchase yet.");
//       return;
//     }

//     const userId = sessionStorage.getItem("userId");
//     if (!userId) {
//       alert("Please login first!");
//       navigate("/login");
//       return;
//     }

//     const strId = String(prod_id);

//     // Already added — do nothing (same as product page)
//     if (addedItems.includes(strId)) return;

//     setLoadingItem(prod_id);

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId),
//         prod_id: Number(prod_id),
//         qty: 1,
//       });

//       if (res.data.status === true) {
//         // Toggle to "Added" state
//         setAddedItems((prev) => [...prev, strId]);
//         // Increment cart count in header
//         setCartCount((prev) => prev + 1);
//       } else {
//         alert(res.data.message || "Failed to add to cart");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Something went wrong");
//     } finally {
//       setLoadingItem(null);
//     }
//   };

//   return (
//     <>
//       <Layout />

//       <div style={{ background: "#f8f9fb", minHeight: "100vh", padding: "40px 0" }}>
//         <div className="container">

//           {/* Page Title */}
//           <div className="mb-4">
//             <h2 className="fw-bold fs-2 mb-4 text-center">E-Books</h2>
//             {/* <p className="text-muted mb-0">Browse and purchase our digital books</p> */}
//           </div>

//           {/* Grid — exactly 3 per row */}
//           <div className="row g-4">
//             {pdfs.map((item) => {
//               const strProdId = String(item.prod_id);
//               const isAdded = addedItems.includes(strProdId);
//               const isLoading = loadingItem === item.prod_id;
//               const hasPrice = item.current_price && Number(item.current_price) > 0;
//               const hasOldPrice = item.old_price && Number(item.old_price) > 0;

//               return (
//                 <div className="col-12 col-sm-6 col-md-4" key={item.pdf_id}>
//                   <div
//                     style={{
//                       background: "#fff",
//                       borderRadius: "16px",
//                       overflow: "hidden",
//                       boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
//                       display: "flex",
//                       flexDirection: "column",
//                       height: "100%",
//                       border: "1px solid #ebebeb",
//                       transition: "transform 0.2s ease, box-shadow 0.2s ease",
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.transform = "translateY(-5px)";
//                       e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.12)";
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.transform = "translateY(0)";
//                       e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.07)";
//                     }}
//                   >
//                     {/* PDF Cover */}
//                     <div
//                     onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}

//                       style={{
//                         width: "100%",
//                         height: "220px",
//                         background: "#f0f2f5",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <iframe
//                         src={`${BASE_URL}/${item.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
//                         title={item.name}
//                         style={{
//                           width: "100%",
//                           height: "100%",
//                           border: "none",
//                           pointerEvents: "none",
//                         }}
//                       />
//                     </div>

//                     {/* Card Body */}
//                     <div
//                       style={{
//                         padding: "16px 18px 18px",
//                         display: "flex",
//                         flexDirection: "column",
//                         flex: 1,
//                         gap: "8px",
//                       }}
//                     >
//                       {/* Name — 1 line with ellipsis */}
//                       <h6
//                        onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
//                         style={{
//                           fontWeight: "700",
//                           fontSize: "15px",
//                           margin: 0,
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           color: "#1a1a2e",
//                         }}
//                         title={item.name}
//                       >
//                         {item.name}
//                       </h6>

//                       {/* Description — 2 lines with ellipsis */}
//                       <p
//                         style={{
//                           fontSize: "13px",
//                           color: "#777",
//                           margin: 0,
//                           display: "-webkit-box",
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                           lineHeight: "1.6",
//                           minHeight: "42px",
//                         }}
//                       >
//                         {item.description || "\u00A0"}
//                       </p>

//                       {/* Divider */}
//                       <hr style={{ margin: "4px 0", borderColor: "#f0f0f0" }} />

//                       {/* Price Row */}
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "10px",
//                         }}
//                       >
//                         {hasPrice ? (
//                           <>
//                             {/* Current price — green */}
//                             <span
//                               style={{
//                                 fontWeight: "800",
//                                 fontSize: "18px",
//                                 color: "#27ae60",
//                               }}
//                             >
//                               ₹{Number(item.current_price).toLocaleString()}
//                             </span>

//                             {/* Old price — strikethrough */}
//                             {hasOldPrice && (
//                               <span
//                                 style={{
//                                   fontSize: "13px",
//                                   color: "#aaa",
//                                   textDecoration: "line-through",
//                                 }}
//                               >
//                                 ₹{Number(item.old_price).toLocaleString()}
//                               </span>
//                             )}
//                           </>
//                         ) : (
//                           <span
//                             style={{
//                               fontSize: "13px",
//                               color: "#bbb",
//                               fontStyle: "italic",
//                             }}
//                           >
//                             Price not available
//                           </span>
//                         )}
//                       </div>

//                       {/* Add to Cart / Added Button — same toggle as product page */}
//                       <div
//                         onClick={() =>
//                           !isAdded && !isLoading && handleAddToCart(item.prod_id)
//                         }
//                         style={{
//                           marginTop: "auto",
//                           padding: "11px 0",
//                           borderRadius: "10px",
//                           fontSize: "14px",
//                           fontWeight: "700",
//                           border: "none",
//                           cursor: isAdded || !item.prod_id ? "default" : "pointer",
//                           background: !item.prod_id
//                             ? "#e0e0e0"
//                             : isAdded
//                             ? "#24aeb1"
//                             : "#24aeb1",
//                           color: !item.prod_id ? "#999" : "#fff",
//                           width: "100%",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "8px",
//                           letterSpacing: "0.3px",
//                           transition: "background 0.3s",
//                           userSelect: "none",
//                         }}
//                       >
//                         {isLoading ? (
//                           <span
//                             className="spinner-border spinner-border-sm"
//                             role="status"
//                           />
//                         ) : isAdded ? (
//                           <>
//                             Added{" "}
//                             <i className="bi bi-check2" style={{ fontSize: "16px" }}></i>
//                           </>
//                         ) : !item.prod_id ? (
//                           <>
//                             <i className="bi bi-x-circle"></i> Unavailable
//                           </>
//                         ) : (
//                           <>
//                             Add to Cart{" "}
//                             <i className="bi bi-bag" style={{ fontSize: "15px" }}></i>
//                           </>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}

//             {/* Empty state */}
//             {pdfs.length === 0 && (
//               <div className="col-12 text-center py-5">
//                 <i
//                   className="bi bi-journal-x"
//                   style={{ fontSize: "56px", color: "#ccc" }}
//                 ></i>
//                 <h5 className="text-muted mt-3 fw-semibold">
//                   No E-Books available yet
//                 </h5>
//                 <p className="text-muted" style={{ fontSize: "14px" }}>
//                   Check back soon for new books!
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <FooterNew />
//     </>
//   );
// };

// export default Ebooks;


// import React, { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../Context/CartContext";

// const BASE_URL = "https://ecom.cyberathon.com";

// // ── Strip HTML tags for clean text display ──────────────────────────────────
// const stripHtml = (html) => {
//   if (!html) return "";
//   const tmp = document.createElement("div");
//   tmp.innerHTML = html;
//   return tmp.textContent || tmp.innerText || "";
// };

// // ── Lock Icon ────────────────────────────────────────────────────────────────
// const LockIcon = () => (
//   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//     <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
//   </svg>
// );

// // ── Unlock Icon ──────────────────────────────────────────────────────────────
// const UnlockIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//     <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
//   </svg>
// );

// // ── Book Icon ────────────────────────────────────────────────────────────────
// const BookIcon = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
//     <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
//   </svg>
// );

// // ── Cart Icon ────────────────────────────────────────────────────────────────
// const CartIcon = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
//     <line x1="3" y1="6" x2="21" y2="6"/>
//     <path d="M16 10a4 4 0 0 1-8 0"/>
//   </svg>
// );

// const Ebooks = () => {
//   const navigate = useNavigate();
//   const { setCartCount } = useCart();

//   const [pdfs, setPdfs] = useState([]);
//   const [addedItems, setAddedItems] = useState([]);
//   const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
//   const [loadingItem, setLoadingItem] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [openPdfId, setOpenPdfId] = useState(null); // for modal viewer

//   // ── Fetch PDFs ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/index.php/Api/list_pdf`)
//       .then((res) => {
//         if (res.data.status) setPdfs(res.data.data);
//       })
//       .catch(console.error)
//       .finally(() => setLoading(false));
//   }, []);

//   // ── Fetch cart + purchased orders ─────────────────────────────────────────
//   useEffect(() => {
//     const init = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const cartToken = localStorage.getItem("cart_token");

//       // 1. Cart items
//       if (userId || cartToken) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//             user_id: userId || null,
//             cart_token: userId ? null : cartToken,
//           });
//           if (res.data.status) {
//             const ids = res.data.cart_items.map((i) => String(i.prod_id));
//             setAddedItems(ids);
//           }
//         } catch (err) {
//           console.error("Cart load error:", err);
//         }
//       }

//       // 2. Purchased orders — only if logged in
//       if (userId) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_new_order`, {
//             user_id: parseInt(userId),
//           });
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             const purchasedIds = new Set();
//             res.data.orders.forEach((order) => {
//               // Only count paid / purchase_status = 'yes'
//               const isPurchased =
//                 order.payment_status === "Paid" ||
//                 (Array.isArray(order.items) &&
//                   order.items.some((item) => item.access === "unlocked"));

//               if (isPurchased && Array.isArray(order.items)) {
//                 order.items.forEach((item) => {
//                   if (item.prod_id) purchasedIds.add(String(item.prod_id));
//                 });
//               }
//             });
//             setPurchasedProdIds(purchasedIds);
//           }
//         } catch (err) {
//           console.error("Orders load error:", err);
//         }
//       }
//     };

//     init();
//   }, []);

//   // ── Add to cart ───────────────────────────────────────────────────────────
//   const handleAddToCart = async (prod_id) => {
//     if (!prod_id) {
//       alert("This item is not available for purchase yet.");
//       return;
//     }
//     const userId = sessionStorage.getItem("userId");
//     if (!userId) {
//       alert("Please login first!");
//       navigate("/login");
//       return;
//     }
//     const strId = String(prod_id);
//     if (addedItems.includes(strId)) return;

//     setLoadingItem(prod_id);
//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId),
//         prod_id: Number(prod_id),
//         qty: 1,
//       });
//       if (res.data.status === true) {
//         setAddedItems((prev) => [...prev, strId]);
//         setCartCount((prev) => prev + 1);
//       } else {
//         alert(res.data.message || "Failed to add to cart");
//       }
//     } catch {
//       alert("Something went wrong");
//     } finally {
//       setLoadingItem(null);
//     }
//   };

//   // ── Open PDF (purchased only) ─────────────────────────────────────────────
//   const handleOpenPdf = (item) => {
//     setOpenPdfId(item.pdf_id);
//   };

//   const activePdf = pdfs.find((p) => p.pdf_id === openPdfId);

//   return (
//     <>
//       <Layout />

//       {/* ── Injected styles ── */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

//         .ebooks-root {
//           background: #f5f4f0;
//           min-height: 100vh;
//           font-family: 'DM Sans', sans-serif;
//           padding: 48px 0 80px;
//         }

//         .ebooks-title {
//           font-family: 'Playfair Display', serif;
//           font-size: clamp(2rem, 4vw, 2.8rem);
//           font-weight: 800;
//           color: #1c1a14;
//           letter-spacing: -0.5px;
//           margin-bottom: 6px;
//         }

//         .ebooks-subtitle {
//           font-size: 15px;
//           color: #888;
//           margin-bottom: 0;
//         }

//         /* ── CARD ── */
//         .ebook-card {
//           background: #fff;
//           border-radius: 18px;
//           overflow: hidden;
//           border: 1px solid #e8e5dc;
//           display: flex;
//           flex-direction: column;
//           height: 100%;
//           transition: transform 0.25s ease, box-shadow 0.25s ease;
//           position: relative;
//         }
//         .ebook-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 20px 40px rgba(0,0,0,0.10);
//         }

//         /* ── COVER ── */
//         .ebook-cover {
//           position: relative;
//           width: 100%;
//           height: 230px;
//           background: #f0ece0;
//           overflow: hidden;
//           cursor: pointer;
//         }
//         .ebook-cover iframe {
//           width: 100%;
//           height: 100%;
//           border: none;
//           pointer-events: none;
//         }
//         .ebook-cover.locked iframe {
//           filter: blur(3px);
//           opacity: 0.6;
//         }
//         .lock-overlay {
//           position: absolute;
//           inset: 0;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           background: rgba(28, 26, 20, 0.45);
//           gap: 8px;
//           color: #fff;
//         }
//         .lock-overlay span {
//           font-size: 12px;
//           font-weight: 600;
//           letter-spacing: 0.5px;
//           text-transform: uppercase;
//           opacity: 0.9;
//         }

//         /* ── BADGE ── */
//         .ebook-badge {
//           position: absolute;
//           top: 12px;
//           right: 12px;
//           background: #27ae60;
//           color: #fff;
//           font-size: 10.5px;
//           font-weight: 700;
//           padding: 3px 9px;
//           border-radius: 20px;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//           z-index: 2;
//         }
//         .ebook-badge.locked-badge {
//           background: #b0a898;
//         }

//         /* ── BODY ── */
//         .ebook-body {
//           padding: 18px 18px 20px;
//           display: flex;
//           flex-direction: column;
//           flex: 1;
//           gap: 10px;
//         }
//         .ebook-name {
//           font-family: 'Playfair Display', serif;
//           font-size: 16px;
//           font-weight: 700;
//           color: #1c1a14;
//           margin: 0;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           cursor: pointer;
//         }
//         .ebook-name:hover { color: #24aeb1; }

//         .ebook-desc {
//           font-size: 13px;
//           color: #888;
//           margin: 0;
//           display: -webkit-box;
//           -webkit-line-clamp: 2;
//           -webkit-box-orient: vertical;
//           overflow: hidden;
//           line-height: 1.65;
//           min-height: 43px;
//         }

//         .ebook-divider {
//           border: none;
//           border-top: 1px solid #f0ece0;
//           margin: 2px 0;
//         }

//         /* ── PRICE ── */
//         .ebook-price-row {
//           display: flex;
//           align-items: baseline;
//           gap: 10px;
//         }
//         .price-current {
//           font-size: 20px;
//           font-weight: 800;
//           color: #27ae60;
//           font-family: 'DM Sans', sans-serif;
//         }
//         .price-old {
//           font-size: 13px;
//           color: #bbb;
//           text-decoration: line-through;
//         }
//         .price-na {
//           font-size: 13px;
//           color: #bbb;
//           font-style: italic;
//         }

//         /* ── BUTTONS ── */
//         .btn-open-pdf {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           padding: 11px 0;
//           border-radius: 11px;
//           border: none;
//           font-size: 14px;
//           font-weight: 700;
//           cursor: pointer;
//           background: linear-gradient(135deg, #27ae60, #1e8449);
//           color: #fff;
//           width: 100%;
//           letter-spacing: 0.3px;
//           transition: opacity 0.2s;
//           margin-top: auto;
//         }
//         .btn-open-pdf:hover { opacity: 0.88; }

//         .btn-add-cart {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           padding: 11px 0;
//           border-radius: 11px;
//           border: none;
//           font-size: 14px;
//           font-weight: 700;
//           cursor: pointer;
//           background: #24aeb1;
//           color: #fff;
//           width: 100%;
//           letter-spacing: 0.3px;
//           transition: opacity 0.2s, background 0.2s;
//           margin-top: auto;
//           user-select: none;
//         }
//         .btn-add-cart.added {
//           background: #1d8c8e;
//           cursor: default;
//         }
//         .btn-add-cart.unavailable {
//           background: #e0e0e0;
//           color: #999;
//           cursor: default;
//         }
//         .btn-add-cart:not(.added):not(.unavailable):hover { opacity: 0.88; }

//         /* ── LOADING SKELETON ── */
//         .skeleton {
//           background: linear-gradient(90deg, #f0ece0 25%, #e8e5dc 50%, #f0ece0 75%);
//           background-size: 200% 100%;
//           animation: shimmer 1.4s infinite;
//           border-radius: 10px;
//         }
//         @keyframes shimmer {
//           0% { background-position: -200% 0; }
//           100% { background-position: 200% 0; }
//         }

//         /* ── MODAL ── */
//         .pdf-modal-overlay {
//           position: fixed;
//           inset: 0;
//           background: rgba(0,0,0,0.75);
//           z-index: 9999;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 20px;
//           animation: fadeIn 0.2s ease;
//         }
//         @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

//         .pdf-modal {
//           background: #1c1a14;
//           border-radius: 16px;
//           width: 100%;
//           max-width: 900px;
//           height: 90vh;
//           display: flex;
//           flex-direction: column;
//           overflow: hidden;
//           box-shadow: 0 40px 80px rgba(0,0,0,0.5);
//         }
//         .pdf-modal-header {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 16px 22px;
//           background: #272520;
//           border-bottom: 1px solid #3a3730;
//         }
//         .pdf-modal-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 16px;
//           color: #f5f4f0;
//           margin: 0;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           max-width: 70%;
//         }
//         .pdf-modal-close {
//           background: #3a3730;
//           border: none;
//           color: #ccc;
//           width: 34px;
//           height: 34px;
//           border-radius: 8px;
//           font-size: 20px;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: background 0.2s;
//         }
//         .pdf-modal-close:hover { background: #e74c3c; color: #fff; }
//         .pdf-modal-body {
//           flex: 1;
//           overflow: hidden;
//         }
//         .pdf-modal-body iframe {
//           width: 100%;
//           height: 100%;
//           border: none;
//         }

//         /* ── EMPTY STATE ── */
//         .empty-state {
//           text-align: center;
//           padding: 80px 20px;
//         }
//         .empty-icon {
//           font-size: 64px;
//           margin-bottom: 16px;
//           opacity: 0.3;
//           display: block;
//         }

//         /* ── STAGGER ANIMATION ── */
//         .ebook-col {
//           animation: slideUp 0.4s ease both;
//         }
//         @keyframes slideUp {
//           from { opacity: 0; transform: translateY(24px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>

//       <div className="ebooks-root">
//         <div className="container">

//           {/* ── Header ── */}
//           <div className="text-center mb-5">
//             <h1 className="ebooks-title">E-Books</h1>
//             <p className="ebooks-subtitle">Browse and purchase our digital library</p>
//           </div>

//           {/* ── Grid ── */}
//           <div className="row g-4">

//             {/* Loading skeletons */}
//             {loading && [1, 2, 3, 4, 5, 6].map((n) => (
//               <div className="col-12 col-sm-6 col-md-4" key={n}>
//                 <div style={{ borderRadius: 18, overflow: "hidden", border: "1px solid #e8e5dc", background: "#fff" }}>
//                   <div className="skeleton" style={{ height: 230 }} />
//                   <div style={{ padding: "18px" }}>
//                     <div className="skeleton" style={{ height: 20, marginBottom: 10, borderRadius: 6 }} />
//                     <div className="skeleton" style={{ height: 14, marginBottom: 6, borderRadius: 6, width: "80%" }} />
//                     <div className="skeleton" style={{ height: 14, borderRadius: 6, width: "60%" }} />
//                     <div className="skeleton" style={{ height: 44, marginTop: 20, borderRadius: 11 }} />
//                   </div>
//                 </div>
//               </div>
//             ))}

//             {/* Book cards */}
//             {!loading && pdfs.map((item, idx) => {
//               const strProdId = String(item.prod_id);
//               const isPurchased = purchasedProdIds.has(strProdId);
//               const isAdded = addedItems.includes(strProdId);
//               const isLoading = loadingItem === item.prod_id;
//               const hasPrice = item.current_price && Number(item.current_price) > 0;
//               const hasOldPrice = item.old_price && Number(item.old_price) > 0;
//               const cleanDesc = stripHtml(item.description);

//               return (
//                 <div
//                   className="col-12 col-sm-6 col-md-4 ebook-col"
//                   key={item.pdf_id}
//                   style={{ animationDelay: `${idx * 60}ms` }}
//                 >
//                   <div className="ebook-card">

//                     {/* ── Purchased / Locked badge ── */}
//                     {item.prod_id && (
//                       <div className={`ebook-badge${isPurchased ? "" : " locked-badge"}`}>
//                         {isPurchased
//                           ? <><UnlockIcon /> Purchased</>
//                           : <><LockIcon /> <span style={{ fontSize: 10 }}>Locked</span></>
//                         }
//                       </div>
//                     )}

//                     {/* ── Cover ── */}
//                     <div
//                       className={`ebook-cover${isPurchased ? "" : " locked"}`}
//                       onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
//                     >
//                       {item.pdf ? (
//                         <iframe
//                           src={`${BASE_URL}/${item.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
//                           title={item.name}
//                         />
//                       ) : (
//                         <div style={{
//                           width: "100%", height: "100%",
//                           display: "flex", alignItems: "center", justifyContent: "center",
//                           color: "#ccc", fontSize: 40
//                         }}>📖</div>
//                       )}

//                       {/* Lock overlay for non-purchased */}
//                       {!isPurchased && (
//                         <div className="lock-overlay">
//                           <LockIcon />
//                           <span>Purchase to Access</span>
//                         </div>
//                       )}
//                     </div>

//                     {/* ── Body ── */}
//                     <div className="ebook-body">

//                       {/* Name */}
//                       <h6
//                         className="ebook-name"
//                         onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
//                         title={item.name}
//                       >
//                         {item.name || "Untitled Book"}
//                       </h6>

//                       {/* Description — HTML stripped */}
//                       <p className="ebook-desc" title={cleanDesc}>
//                         {cleanDesc || "\u00A0"}
//                       </p>

//                       <hr className="ebook-divider" />

//                       {/* Price */}
//                       <div className="ebook-price-row">
//                         {hasPrice ? (
//                           <>
//                             <span className="price-current">
//                               ₹{Number(item.current_price).toLocaleString()}
//                             </span>
//                             {hasOldPrice && (
//                               <span className="price-old">
//                                 ₹{Number(item.old_price).toLocaleString()}
//                               </span>
//                             )}
//                           </>
//                         ) : (
//                           <span className="price-na">Price not available</span>
//                         )}
//                       </div>

//                       {/* ── CTA ── */}
//                       {isPurchased ? (
//                         /* Already purchased — show Open PDF */
//                         <button
//                           className="btn-open-pdf"
//                           onClick={() => handleOpenPdf(item)}
//                         >
//                           <BookIcon />
//                           Open PDF
//                         </button>
//                       ) : (
//                         /* Not purchased — show Add to Cart */
//                         <button
//                           className={`btn-add-cart${isAdded ? " added" : ""}${!item.prod_id ? " unavailable" : ""}`}
//                           onClick={() => !isAdded && !isLoading && handleAddToCart(item.prod_id)}
//                           disabled={isLoading}
//                         >
//                           {isLoading ? (
//                             <span className="spinner-border spinner-border-sm" role="status" />
//                           ) : isAdded ? (
//                             <>Added ✓</>
//                           ) : !item.prod_id ? (
//                             <>Unavailable</>
//                           ) : (
//                             <><CartIcon /> Add to Cart</>
//                           )}
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}

//             {/* Empty state */}
//             {!loading && pdfs.length === 0 && (
//               <div className="col-12">
//                 <div className="empty-state">
//                   <span className="empty-icon">📚</span>
//                   <h5 style={{ color: "#888", fontWeight: 600 }}>No E-Books available yet</h5>
//                   <p style={{ color: "#bbb", fontSize: 14 }}>Check back soon for new books!</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ── PDF Viewer Modal ─────────────────────────────────────────────── */}
//       {openPdfId && activePdf && (
//         <div className="pdf-modal-overlay" onClick={() => setOpenPdfId(null)}>
//           <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="pdf-modal-header">
//               <p className="pdf-modal-title">{activePdf.name}</p>
//               <button className="pdf-modal-close" onClick={() => setOpenPdfId(null)}>
//                 ×
//               </button>
//             </div>
//             <div className="pdf-modal-body">
//               <iframe
//                 src={`${BASE_URL}/${activePdf.pdf}#toolbar=1&navpanes=0`}
//                 title={activePdf.name}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       <FooterNew />
//     </>
//   );
// };

// export default Ebooks;

// Without claude 19feb withgpt 
// import React, { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../Context/CartContext";

// const BASE_URL = "https://ecom.cyberathon.com";

// // ── Strip HTML tags for clean text display ──────────────────────────────────
// const stripHtml = (html) => {
//   if (!html) return "";
//   const tmp = document.createElement("div");
//   tmp.innerHTML = html;
//   return tmp.textContent || tmp.innerText || "";
// };

// // ── Lock Icon ────────────────────────────────────────────────────────────────
// const LockIcon = () => (
//   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//     <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
//   </svg>
// );

// // ── Unlock Icon ──────────────────────────────────────────────────────────────
// const UnlockIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//     <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
//   </svg>
// );

// // ── Book Icon ────────────────────────────────────────────────────────────────
// const BookIcon = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
//     <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
//   </svg>
// );

// // ── Cart Icon ────────────────────────────────────────────────────────────────
// const CartIcon = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
//     <line x1="3" y1="6" x2="21" y2="6"/>
//     <path d="M16 10a4 4 0 0 1-8 0"/>
//   </svg>
// );

// const Ebooks = () => {
//   const navigate = useNavigate();
//   const { setCartCount } = useCart();

//   const [pdfs, setPdfs] = useState([]);
//   const [addedItems, setAddedItems] = useState([]);
//   const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
//   const [loadingItem, setLoadingItem] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [openPdfId, setOpenPdfId] = useState(null); // for modal viewer

//   // ── Fetch PDFs ─────────────────────────────────────────────────────────────
//   // useEffect(() => {
//   //   axios
//   //     .get(`${BASE_URL}/index.php/Api/list_pdf`)
//   //     .then((res) => {
//   //       if (res.data.status) setPdfs(res.data.data);
//   //     })
//   //     .catch(console.error)
//   //     .finally(() => setLoading(false));
//   // }, []);

//   useEffect(() => {
//   axios
//     .get(`${BASE_URL}/index.php/Api/list_get_product`)
//     .then((res) => {
//       if (res.data.status) {
//         // ✅ Filter only ebooks
//         const ebooksOnly = res.data.products.filter(
//           (item) => item.product_type?.toLowerCase() === "ebook"
//         );

//         setPdfs(ebooksOnly);
//       }
//     })
//     .catch(console.error)
//     .finally(() => setLoading(false));
// }, []);
//   // ── Fetch cart + purchased orders ─────────────────────────────────────────
//   useEffect(() => {
//     const init = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const cartToken = localStorage.getItem("cart_token");

//       // 1. Cart items
//       if (userId || cartToken) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//             user_id: userId || null,
//             cart_token: userId ? null : cartToken,
//           });
//           if (res.data.status) {
//             const ids = res.data.cart_items.map((i) => String(i.prod_id));
//             setAddedItems(ids);
//           }
//         } catch (err) {
//           console.error("Cart load error:", err);
//         }
//       }

//       // 2. Purchased orders — only if logged in
//       if (userId) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_new_order`, {
//             user_id: parseInt(userId),
//           });
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             const purchasedIds = new Set();
//             res.data.orders.forEach((order) => {
//               if (!Array.isArray(order.items)) return;

//               order.items.forEach((item) => {
//                 if (!item.prod_id) return;

//                 // ✅ Check 1: item-level access field (set by backend based on purchase_status)
//                 if (item.access === "unlocked") {
//                   purchasedIds.add(String(item.prod_id));
//                   return;
//                 }

//                 // ✅ Check 2: order-level purchase_status field
//                 if (order.purchase_status === "yes") {
//                   purchasedIds.add(String(item.prod_id));
//                   return;
//                 }

//                 // ✅ Check 3: payment_status is Paid
//                 if (
//                   order.payment_status === "Paid" ||
//                   order.payment_status === "paid"
//                 ) {
//                   purchasedIds.add(String(item.prod_id));
//                   return;
//                 }

//                 // ✅ Check 4: order_status is Delivered or Completed
//                 if (
//                   order.order_status === "Delivered" ||
//                   order.order_status === "Completed"
//                 ) {
//                   purchasedIds.add(String(item.prod_id));
//                   return;
//                 }
//               });
//             });
//             setPurchasedProdIds(purchasedIds);
//           }
//         } catch (err) {
//           console.error("Orders load error:", err);
//         }
//       }
//     };

//     init();
//   }, []);

//   // ── Add to cart ───────────────────────────────────────────────────────────
//   const handleAddToCart = async (prod_id) => {
//     if (!prod_id) {
//       alert("This item is not available for purchase yet.");
//       return;
//     }
//     const userId = sessionStorage.getItem("userId");
//     if (!userId) {
//       alert("Please login first!");
//       navigate("/login");
//       return;
//     }
//     const strId = String(prod_id);
//     if (addedItems.includes(strId)) return;

//     setLoadingItem(prod_id);
//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId),
//         prod_id: Number(prod_id),
//         qty: 1,
//       });
//       if (res.data.status === true) {
//         setAddedItems((prev) => [...prev, strId]);
//         setCartCount((prev) => prev + 1);
//       } else {
//         alert(res.data.message || "Failed to add to cart");
//       }
//     } catch {
//       alert("Something went wrong");
//     } finally {
//       setLoadingItem(null);
//     }
//   };

//   // ── Open PDF (purchased only) ─────────────────────────────────────────────
//   const handleOpenPdf = (item) => {
//     setOpenPdfId(item.prod_id);
//   };

//   const activePdf = pdfs.find((p) => p.prod_id === openPdfId);

//   return (
//     <>
//       <Layout />

//       {/* ── Injected styles ── */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

//         .ebooks-root {
//           background: #f5f4f0;
//           min-height: 100vh;
//           font-family: 'DM Sans', sans-serif;
//           padding: 48px 0 80px;
//         }

//         .ebooks-title {
//           font-family: 'Playfair Display', serif;
//           font-size: clamp(2rem, 4vw, 2.8rem);
//           font-weight: 800;
//           color: #1c1a14;
//           letter-spacing: -0.5px;
//           margin-bottom: 6px;
//         }

//         .ebooks-subtitle {
//           font-size: 15px;
//           color: #888;
//           margin-bottom: 0;
//         }

//         /* ── CARD ── */
//         .ebook-card {
//           background: #fff;
//           border-radius: 18px;
//           overflow: hidden;
//           border: 1px solid #e8e5dc;
//           display: flex;
//           flex-direction: column;
//           height: 100%;
//           transition: transform 0.25s ease, box-shadow 0.25s ease;
//           position: relative;
//         }
//         .ebook-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 20px 40px rgba(0,0,0,0.10);
//         }

//         /* ── COVER ── */
//         .ebook-cover {
//           position: relative;
//           width: 100%;
//           height: 230px;
//           background: #f0ece0;
//           overflow: hidden;
//           cursor: pointer;
//         }
//         .ebook-cover iframe {
//           width: 100%;
//           height: 100%;
//           border: none;
//           pointer-events: none;
//         }
//         .ebook-cover.locked iframe {
//           filter: blur(3px);
//           opacity: 0.6;
//         }
//         .lock-overlay {
//           position: absolute;
//           inset: 0;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           background: rgba(28, 26, 20, 0.45);
//           gap: 8px;
//           color: #fff;
//         }
//         .lock-overlay span {
//           font-size: 12px;
//           font-weight: 600;
//           letter-spacing: 0.5px;
//           text-transform: uppercase;
//           opacity: 0.9;
//         }

//         /* ── BADGE ── */
//         .ebook-badge {
//           position: absolute;
//           top: 12px;
//           right: 12px;
//           background: #27ae60;
//           color: #fff;
//           font-size: 10.5px;
//           font-weight: 700;
//           padding: 3px 9px;
//           border-radius: 20px;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//           z-index: 2;
//         }
//         .ebook-badge.locked-badge {
//           background: #b0a898;
//         }

//         /* ── BODY ── */
//         .ebook-body {
//           padding: 18px 18px 20px;
//           display: flex;
//           flex-direction: column;
//           flex: 1;
//           gap: 10px;
//         }
//         .ebook-name {
//           font-family: 'Playfair Display', serif;
//           font-size: 16px;
//           font-weight: 700;
//           color: #1c1a14;
//           margin: 0;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           cursor: pointer;
//         }
//         .ebook-name:hover { color: #24aeb1; }

//         .ebook-desc {
//           font-size: 13px;
//           color: #888;
//           margin: 0;
//           display: -webkit-box;
//           -webkit-line-clamp: 2;
//           -webkit-box-orient: vertical;
//           overflow: hidden;
//           line-height: 1.65;
//           min-height: 43px;
//         }

//         .ebook-divider {
//           border: none;
//           border-top: 1px solid #f0ece0;
//           margin: 2px 0;
//         }

//         /* ── PRICE ── */
//         .ebook-price-row {
//           display: flex;
//           align-items: baseline;
//           gap: 10px;
//         }
//         .price-current {
//           font-size: 20px;
//           font-weight: 800;
//           color: #27ae60;
//           font-family: 'DM Sans', sans-serif;
//         }
//         .price-old {
//           font-size: 13px;
//           color: #bbb;
//           text-decoration: line-through;
//         }
//         .price-na {
//           font-size: 13px;
//           color: #bbb;
//           font-style: italic;
//         }

//         /* ── BUTTONS ── */
//         .btn-open-pdf {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           padding: 11px 0;
//           border-radius: 11px;
//           border: none;
//           font-size: 14px;
//           font-weight: 700;
//           cursor: pointer;
//           background: linear-gradient(135deg, #27ae60, #1e8449);
//           color: #fff;
//           width: 100%;
//           letter-spacing: 0.3px;
//           transition: opacity 0.2s;
//           margin-top: auto;
//         }
//         .btn-open-pdf:hover { opacity: 0.88; }

//         .btn-add-cart {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           padding: 11px 0;
//           border-radius: 11px;
//           border: none;
//           font-size: 14px;
//           font-weight: 700;
//           cursor: pointer;
//           background: #24aeb1;
//           color: #fff;
//           width: 100%;
//           letter-spacing: 0.3px;
//           transition: opacity 0.2s, background 0.2s;
//           margin-top: auto;
//           user-select: none;
//         }
//         .btn-add-cart.added {
//           background: #1d8c8e;
//           cursor: default;
//         }
//         .btn-add-cart.unavailable {
//           background: #e0e0e0;
//           color: #999;
//           cursor: default;
//         }
//         .btn-add-cart:not(.added):not(.unavailable):hover { opacity: 0.88; }

//         /* ── LOADING SKELETON ── */
//         .skeleton {
//           background: linear-gradient(90deg, #f0ece0 25%, #e8e5dc 50%, #f0ece0 75%);
//           background-size: 200% 100%;
//           animation: shimmer 1.4s infinite;
//           border-radius: 10px;
//         }
//         @keyframes shimmer {
//           0% { background-position: -200% 0; }
//           100% { background-position: 200% 0; }
//         }

//         /* ── MODAL ── */
//         .pdf-modal-overlay {
//           position: fixed;
//           inset: 0;
//           background: rgba(0,0,0,0.75);
//           z-index: 9999;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 20px;
//           animation: fadeIn 0.2s ease;
//         }
//         @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

//         .pdf-modal {
//           background: #1c1a14;
//           border-radius: 16px;
//           width: 100%;
//           max-width: 900px;
//           height: 90vh;
//           display: flex;
//           flex-direction: column;
//           overflow: hidden;
//           box-shadow: 0 40px 80px rgba(0,0,0,0.5);
//         }
//         .pdf-modal-header {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 16px 22px;
//           background: #272520;
//           border-bottom: 1px solid #3a3730;
//         }
//         .pdf-modal-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 16px;
//           color: #f5f4f0;
//           margin: 0;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           max-width: 70%;
//         }
//         .pdf-modal-close {
//           background: #3a3730;
//           border: none;
//           color: #ccc;
//           width: 34px;
//           height: 34px;
//           border-radius: 8px;
//           font-size: 20px;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: background 0.2s;
//         }
//         .pdf-modal-close:hover { background: #e74c3c; color: #fff; }
//         .pdf-modal-body {
//           flex: 1;
//           overflow: hidden;
//         }
//         .pdf-modal-body iframe {
//           width: 100%;
//           height: 100%;
//           border: none;
//         }

//         /* ── EMPTY STATE ── */
//         .empty-state {
//           text-align: center;
//           padding: 80px 20px;
//         }
//         .empty-icon {
//           font-size: 64px;
//           margin-bottom: 16px;
//           opacity: 0.3;
//           display: block;
//         }

//         /* ── STAGGER ANIMATION ── */
//         .ebook-col {
//           animation: slideUp 0.4s ease both;
//         }
//         @keyframes slideUp {
//           from { opacity: 0; transform: translateY(24px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>

//       <div className="ebooks-root">
//         <div className="container">

//           {/* ── Header ── */}
//           <div className="text-center mb-5">
//             <h1 className="ebooks-title">E-Books</h1>
//           </div>

//           {/* ── Grid ── */}
//           <div className="row g-4">

//             {/* Loading skeletons */}
//             {loading && [1, 2, 3, 4, 5, 6].map((n) => (
//               <div className="col-12 col-sm-6 col-md-4" key={n}>
//                 <div style={{ borderRadius: 18, overflow: "hidden", border: "1px solid #e8e5dc", background: "#fff" }}>
//                   <div className="skeleton" style={{ height: 230 }} />
//                   <div style={{ padding: "18px" }}>
//                     <div className="skeleton" style={{ height: 20, marginBottom: 10, borderRadius: 6 }} />
//                     <div className="skeleton" style={{ height: 14, marginBottom: 6, borderRadius: 6, width: "80%" }} />
//                     <div className="skeleton" style={{ height: 14, borderRadius: 6, width: "60%" }} />
//                     <div className="skeleton" style={{ height: 44, marginTop: 20, borderRadius: 11 }} />
//                   </div>
//                 </div>
//               </div>
//             ))}

//             {/* Book cards */}
//             {!loading && pdfs.map((item, idx) => {
//               const strProdId = String(item.prod_id);
//               const isPurchased = purchasedProdIds.has(strProdId);
//               const isAdded = addedItems.includes(strProdId);
//               const isLoading = loadingItem === item.prod_id;
//               const hasPrice = item.current_price && Number(item.current_price) > 0;
//               const hasOldPrice = item.old_price && Number(item.old_price) > 0;
//               const cleanDesc = stripHtml(item.description);

//               return (
//                 <div
//                   className="col-12 col-sm-6 col-md-4 ebook-col"
//                   key={item.prod_id}
//                   style={{ animationDelay: `${idx * 60}ms` }}
//                 >
//                   <div className="ebook-card">

//                     {/* ── Purchased / Locked badge ── */}
//                     {item.prod_id && (
//                       <div className={`ebook-badge${isPurchased ? "" : " locked-badge"}`}>
//                         {isPurchased
//                           ? <><UnlockIcon /> Purchased</>
//                           : <><LockIcon /> <span style={{ fontSize: 10 }}>Locked</span></>
//                         }
//                       </div>
//                     )}

//                     {/* ── Cover ── */}
//                     <div
//                       className={`ebook-cover${isPurchased ? "" : " locked"}`}
//                       onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
//                     >
//                       {item.pdf ? (
//                         <iframe
//                           src={`${BASE_URL}/${item.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
//                           title={item.name}
//                         />
//                       ) : (
//                         <div style={{
//                           width: "100%", height: "100%",
//                           display: "flex", alignItems: "center", justifyContent: "center",
//                           color: "#ccc", fontSize: 40
//                         }}>📖</div>
//                       )}

//                       {/* Lock overlay for non-purchased */}
//                       {!isPurchased && (
//                         <div className="lock-overlay">
//                           <LockIcon />
//                           <span>Purchase to Access</span>
//                         </div>
//                       )}
//                     </div>

//                     {/* ── Body ── */}
//                     <div className="ebook-body">

//                       {/* Name */}
//                       <h6
//                         className="ebook-name"
//                         onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
//                         title={item.name}
//                       >
//                         {item.name || "Untitled Book"}
//                       </h6>

//                       {/* Description — HTML stripped */}
//                       <p className="ebook-desc" title={cleanDesc}>
//                         {cleanDesc || "\u00A0"}
//                       </p>

//                       <hr className="ebook-divider" />

//                       {/* Price */}
//                       <div className="ebook-price-row">
//                         {hasPrice ? (
//                           <>
//                             <span className="price-current">
//                               ₹{Number(item.current_price).toLocaleString()}
//                             </span>
//                             {hasOldPrice && (
//                               <span className="price-old">
//                                 ₹{Number(item.old_price).toLocaleString()}
//                               </span>
//                             )}
//                           </>
//                         ) : (
//                           <span className="price-na">Price not available</span>
//                         )}
//                       </div>

//                       {/* ── CTA ── */}
//                       {isPurchased ? (
//                         /* Already purchased — show Open PDF */
//                         <button
//                           className="btn-open-pdf"
//                           onClick={() => handleOpenPdf(item)}
//                         >
//                           <BookIcon />
//                           Open PDF
//                         </button>
//                       ) : (
//                         /* Not purchased — show Add to Cart */
//                         <button
//                           className={`btn-add-cart${isAdded ? " added" : ""}${!item.prod_id ? " unavailable" : ""}`}
//                           onClick={() => !isAdded && !isLoading && handleAddToCart(item.prod_id)}
//                           disabled={isLoading}
//                         >
//                           {isLoading ? (
//                             <span className="spinner-border spinner-border-sm" role="status" />
//                           ) : isAdded ? (
//                             <>Added ✓</>
//                           ) : !item.prod_id ? (
//                             <>Unavailable</>
//                           ) : (
//                             <><CartIcon /> Add to Cart</>
//                           )}
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}

//             {/* Empty state */}
//             {!loading && pdfs.length === 0 && (
//               <div className="col-12">
//                 <div className="empty-state">
//                   <span className="empty-icon">📚</span>
//                   <h5 style={{ color: "#888", fontWeight: 600 }}>No E-Books available yet</h5>
//                   <p style={{ color: "#bbb", fontSize: 14 }}>Check back soon for new books!</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ── PDF Viewer Modal ─────────────────────────────────────────────── */}
//       {openPdfId && activePdf && (
//         <div className="pdf-modal-overlay" onClick={() => setOpenPdfId(null)}>
//           <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="pdf-modal-header">
//               <p className="pdf-modal-title">{activePdf.name}</p>
//               <button className="pdf-modal-close" onClick={() => setOpenPdfId(null)}>
//                 ×
//               </button>
//             </div>
//             <div className="pdf-modal-body">
//               <iframe
//                 src={`${BASE_URL}/${activePdf.pdf}#toolbar=1&navpanes=0`}
//                 title={activePdf.name}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       <FooterNew />
//     </>
//   );
// };

// export default Ebooks;


// Before 20march
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../Context/CartContext";

// const BASE_URL = "https://ecom.cyberathon.com";
// const getCartToken = () => {
//   let token = localStorage.getItem("cart_token");
//   if (!token) {
//     token = crypto.randomUUID();
//     localStorage.setItem("cart_token", token);
//   }
//   return token;
// };

// // ── Strip HTML tags for clean text display ──────────────────────────────────
// const stripHtml = (html) => {
//   if (!html) return "";
//   const tmp = document.createElement("div");
//   tmp.innerHTML = html;
//   return tmp.textContent || tmp.innerText || "";
// };

// // ── Lock Icon ────────────────────────────────────────────────────────────────
// const LockIcon = () => (
//   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//     <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
//   </svg>
// );

// const UnlockIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//     <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
//   </svg>
// );

// const BookIcon = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
//     <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
//   </svg>
// );

// const CartIcon = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
//     <line x1="3" y1="6" x2="21" y2="6"/>
//     <path d="M16 10a4 4 0 0 1-8 0"/>
//   </svg>
// );


// const normalizeEbook = (item) => ({
//   prod_id:       item.prod_id,
//   // ✅ ebook type uses "name" field — fallback to Product_name just in case
//   name:          item.name || item.Product_name || "Untitled Book",
//   description:   item.description || "",
//   details:       item.details || "",
//   // ✅ pdf is the relative path e.g. "uploads/pdf/xxx.pdf"
//   pdf:           item.pdf || "",
//   current_price: item.current_price || 0,
//   old_price:     item.old_price || 0,
// });

// const Ebooks = () => {
//   const navigate = useNavigate();
//   const { setCartCount } = useCart();

//   const [pdfs, setPdfs]                       = useState([]);
//   const [addedItems, setAddedItems]           = useState([]);
//   const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
//   const [loadingItem, setLoadingItem]         = useState(null);
//   const [loading, setLoading]                 = useState(true);
//   const [openPdfId, setOpenPdfId]             = useState(null);

//   // ── Fetch ebooks from list_get_product, filter product_type === "ebook" ──
//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/index.php/Api/list_get_product`)
//       .then((res) => {
//         if (res.data?.status && Array.isArray(res.data.products)) {
//           const ebooksOnly = res.data.products
//             .filter((item) => item.product_type?.toLowerCase() === "ebook")
//             .map(normalizeEbook);
//           setPdfs(ebooksOnly);
//         }
//       })
//       .catch(console.error)
//       .finally(() => setLoading(false));
//   }, []);

//   // ── Fetch cart + purchased orders ─────────────────────────────────────────
//   useEffect(() => {
//     const init = async () => {
//       const userId    = sessionStorage.getItem("userId");
//       const cartToken = localStorage.getItem("cart_token");

//       // 1. Cart items
//       if (userId || cartToken) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//             user_id:    userId || null,
//             cart_token: userId ? null : cartToken,
//           });
//           if (res.data.status) {
//             const ids = res.data.cart_items.map((i) => String(i.prod_id));
//             setAddedItems(ids);
//           }
//         } catch (err) { console.error("Cart load error:", err); }
//       }

//       // 2. Purchased orders
//       if (userId) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_new_order`, {
//             user_id: parseInt(userId),
//           });
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             const purchasedIds = new Set();
//             res.data.orders.forEach((order) => {
//               if (!Array.isArray(order.items)) return;
//               order.items.forEach((item) => {
//                 if (!item.prod_id) return;
//                 if (
//                   item.access === "unlocked" ||
//                   order.purchase_status === "yes" ||
//                   order.payment_status === "Paid" ||
//                   order.payment_status === "paid" ||
//                   order.order_status === "Delivered" ||
//                   order.order_status === "Completed"
//                 ) {
//                   purchasedIds.add(String(item.prod_id));
//                 }
//               });
//             });
//             setPurchasedProdIds(purchasedIds);
//           }
//         } catch (err) { console.error("Orders load error:", err); }
//       }
//     };

//     init();
//   }, []);

//   // ── Add to cart ───────────────────────────────────────────────────────────
//   // const handleAddToCart = async (prod_id) => {
//   //   if (!prod_id) {
//   //     alert("This item is not available for purchase yet.");
//   //     return;
//   //   }
//   //   const userId = sessionStorage.getItem("userId");
//   //   if (!userId) {
   
//   //     sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
//   //     window.dispatchEvent(new Event("openLoginModal"));

//   //     return;
//   //   }
//   //   const strId = String(prod_id);
//   //   if (addedItems.includes(strId)) return;

//   //   setLoadingItem(prod_id);
//   //   try {
//   //     const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//   //       user_id: Number(userId),
//   //       prod_id: Number(prod_id),
//   //       qty: 1,
//   //     });
//   //     if (res.data.status === true) {
//   //       setAddedItems((prev) => [...prev, strId]);
//   //       setCartCount((prev) => prev + 1);
//   //     } else {
//   //       alert(res.data.message || "Failed to add to cart");
//   //     }
//   //   } catch {
//   //     alert("Something went wrong");
//   //   } finally {
//   //     setLoadingItem(null);
//   //   }
//   // };
//   const handleAddToCart = async (item) => {
//   if (!item?.prod_id) {
//     alert("This item is not available for purchase yet.");
//     return;
//   }

//   const userId = sessionStorage.getItem("userId");
//   const cartToken = !userId ? getCartToken() : null;
//   const strId = String(item.prod_id);

//   if (!userId) {
//     sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
//     window.dispatchEvent(new Event("openLoginModal"));
//     return;
//   }

//   if (addedItems.includes(strId)) return;

//   setLoadingItem(item.prod_id);

//   try {
//     // 1. पहले cart check
//     const listRes = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//       user_id: userId ? userId : null,
//       cart_token: cartToken,
//     });

//     let cartItem = null;

//     if (listRes.data.status) {
//       cartItem = listRes.data.cart_items.find(
//         (i) => String(i.prod_id) === strId
//       );
//     }

//     // 2. अगर already cart me hai, bas added state set karo
//     if (cartItem) {
//       setAddedItems((prev) => (prev.includes(strId) ? prev : [...prev, strId]));
//       return;
//     }

//     // 3. insert cart
//     const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//       user_id: Number(userId),
//       prod_id: Number(item.prod_id),
//       qty: 1,
//     });

//     if (res.data.status === true) {
//       setAddedItems((prev) => [...prev, strId]);
//       setCartCount((prev) => prev + 1);
//     } else {
//       alert(res.data.message || "Failed to add to cart");
//     }
//   } catch (error) {
//     console.error("Add to cart error:", error);
//     alert("Something went wrong");
//   } finally {
//     setLoadingItem(null);
//   }
// };
// const handleBuyNow = async (item) => {
//   if (!item?.prod_id) {
//     alert("This item is not available for purchase yet.");
//     return;
//   }

//   const userId = sessionStorage.getItem("userId");
//   const cartToken = !userId ? getCartToken() : null;

//   if (!userId) {
//     sessionStorage.setItem("redirectAfterLogin", "/Bill");
//     window.dispatchEvent(new Event("openLoginModal"));
//     return;
//   }

//   setLoadingItem(item.prod_id);

//   try {
//     // 1. cart check
//     const listRes = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//       user_id: userId ? userId : null,
//       cart_token: cartToken,
//     });

//     let cartItem = null;

//     if (listRes.data.status) {
//       cartItem = listRes.data.cart_items.find(
//         (i) => String(i.prod_id) === String(item.prod_id)
//       );
//     }

//     // 2. if already cart me hai to update qty
//     if (cartItem) {
//       await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//         cart_id: cartItem.cart_id,
//         quantity: 1,
//         user_id: userId ? userId : null,
//         cart_token: cartToken,
//       });
//     } else {
//       await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId),
//         prod_id: Number(item.prod_id),
//         qty: 1,
//       });

//       setAddedItems((prev) => [...prev, String(item.prod_id)]);
//       setCartCount((prev) => prev + 1);
//     }

//     navigate("/Bill");
//   } catch (error) {
//     console.error("Buy now error:", error);
//     alert("Something went wrong");
//   } finally {
//     setLoadingItem(null);
//   }
// };

//   // ── Open PDF modal (purchased only) ──────────────────────────────────────
//   const handleOpenPdf = (item) => {
//     setOpenPdfId(item.prod_id);
//   };

//   const activePdf = pdfs.find((p) => String(p.prod_id) === String(openPdfId));

//   return (
//     <>
//       <Layout />

//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

//         .ebooks-root {
//           background: #f5f4f0;
//           min-height: 100vh;
//           font-family: 'DM Sans', sans-serif;
//           padding: 48px 0 80px;
//         }
//         .ebooks-title {
//           font-family: 'Playfair Display', serif;
//           font-size: clamp(2rem, 4vw, 2.8rem);
//           font-weight: 800;
//           color: #1c1a14;
//           letter-spacing: -0.5px;
//           margin-bottom: 6px;
//         }
//         .ebook-card {
//           background: #fff;
//           border-radius: 18px;
//           overflow: hidden;
//           border: 1px solid #e8e5dc;
//           display: flex;
//           flex-direction: column;
//           height: 100%;
//           transition: transform 0.25s ease, box-shadow 0.25s ease;
//           position: relative;
//         }
//         .ebook-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 20px 40px rgba(0,0,0,0.10);
//         }
//         .ebook-cover {
//           position: relative;
//           width: 100%;
//           height: 230px;
//           background: #f0ece0;
//           overflow: hidden;
//           cursor: pointer;
//         }
//         .ebook-cover iframe {
//           width: 100%;
//           height: 100%;
//           border: none;
//           pointer-events: none;
//         }
//         .ebook-cover.locked iframe {
//           filter: blur(3px);
//           opacity: 0.6;
//         }
//         .lock-overlay {
//           position: absolute;
//           inset: 0;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           background: rgba(28,26,20,0.45);
//           gap: 8px;
//           color: #fff;
//         }
//         .lock-overlay span {
//           font-size: 12px;
//           font-weight: 600;
//           letter-spacing: 0.5px;
//           text-transform: uppercase;
//           opacity: 0.9;
//         }
//         .ebook-badge {
//           position: absolute;
//           top: 12px;
//           right: 12px;
//           background: #27ae60;
//           color: #fff;
//           font-size: 10.5px;
//           font-weight: 700;
//           padding: 3px 9px;
//           border-radius: 20px;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//           z-index: 2;
//         }
//         .ebook-badge.locked-badge { background: #b0a898; }
//         .ebook-body {
//           padding: 18px 18px 20px;
//           display: flex;
//           flex-direction: column;
//           flex: 1;
//           gap: 10px;
//         }
//         .ebook-name {
//           font-family: 'Playfair Display', serif;
//           font-size: 16px;
//           font-weight: 700;
//           color: #1c1a14;
//           margin: 0;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           cursor: pointer;
//         }
//         .ebook-name:hover { color: #24aeb1; }
//         .ebook-desc {
//           font-size: 13px;
//           color: #888;
//           margin: 0;
//           display: -webkit-box;
//           -webkit-line-clamp: 2;
//           -webkit-box-orient: vertical;
//           overflow: hidden;
//           line-height: 1.65;
//           min-height: 43px;
//         }
//         .ebook-divider { border: none; border-top: 1px solid #f0ece0; margin: 2px 0; }
//         .ebook-price-row { display: flex; align-items: baseline; gap: 10px; }
//         .price-current { font-size: 20px; font-weight: 800; color: #27ae60; font-family: 'DM Sans', sans-serif; }
//         .price-old { font-size: 13px; color: #bbb; text-decoration: line-through; }
//         .price-na { font-size: 13px; color: #bbb; font-style: italic; }
//         .btn-open-pdf {
//           display: flex; align-items: center; justify-content: center; gap: 8px;
//           padding: 11px 0; border-radius: 11px; border: none;
//           font-size: 14px; font-weight: 700; cursor: pointer;
//           background: linear-gradient(135deg, #27ae60, #1e8449);
//           color: #fff; width: 100%; letter-spacing: 0.3px;
//           transition: opacity 0.2s; margin-top: auto;
//         }
//         .btn-open-pdf:hover { opacity: 0.88; }
//         .ebook-action-row {
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 10px;
//   margin-top: auto;
// }

// .btn-buy-now {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;
//   padding: 11px 0;
//   border-radius: 11px;
//   border: none;
//   font-size: 14px;
//   font-weight: 700;
//   cursor: pointer;
//   background:#24aeb1;
//   color: #fff;
//   width: 100%;
//   letter-spacing: 0.3px;
//   transition: opacity 0.2s, background 0.2s;
// }

// .btn-buy-now:hover {
//   opacity: 0.88;
// }

// .btn-buy-now:disabled {
//   background: #cfcfcf;
//   color: #888;
//   cursor: not-allowed;
// }

// @media (max-width: 576px) {
//   .ebook-action-row {
//     grid-template-columns: 1fr;
//   }
// }
//         .btn-add-cart {
//           display: flex; align-items: center; justify-content: center; gap: 8px;
//           padding: 11px 0; border-radius: 11px; border: none;
//           font-size: 14px; font-weight: 700; cursor: pointer;
//           background: #24aeb1; color: #fff; width: 100%;
//           letter-spacing: 0.3px; transition: opacity 0.2s, background 0.2s;
//           margin-top: auto; user-select: none;
//         }
//         .btn-add-cart.added { background: #1d8c8e; cursor: default; }
//         .btn-add-cart.unavailable { background: #e0e0e0; color: #999; cursor: default; }
//         .btn-add-cart:not(.added):not(.unavailable):hover { opacity: 0.88; }
//         .skeleton {
//           background: linear-gradient(90deg, #f0ece0 25%, #e8e5dc 50%, #f0ece0 75%);
//           background-size: 200% 100%;
//           animation: shimmer 1.4s infinite;
//           border-radius: 10px;
//         }
//         @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
//         .pdf-modal-overlay {
//           position: fixed; inset: 0; background: rgba(0,0,0,0.75);
//           z-index: 9999; display: flex; align-items: center; justify-content: center;
//           padding: 20px; animation: fadeIn 0.2s ease;
//         }
//         @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
//         .pdf-modal {
//           background: #1c1a14; border-radius: 16px; width: 100%; max-width: 900px;
//           height: 90vh; display: flex; flex-direction: column; overflow: hidden;
//           box-shadow: 0 40px 80px rgba(0,0,0,0.5);
//         }
//         .pdf-modal-header {
//           display: flex; align-items: center; justify-content: space-between;
//           padding: 16px 22px; background: #272520; border-bottom: 1px solid #3a3730;
//         }
//         .pdf-modal-title {
//           font-family: 'Playfair Display', serif; font-size: 16px; color: #f5f4f0;
//           margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 70%;
//         }
//         .pdf-modal-close {
//           background: #3a3730; border: none; color: #ccc;
//           width: 34px; height: 34px; border-radius: 8px; font-size: 20px;
//           cursor: pointer; display: flex; align-items: center; justify-content: center;
//           transition: background 0.2s;
//         }
//         .pdf-modal-close:hover { background: #e74c3c; color: #fff; }
//         .pdf-modal-body { flex: 1; overflow: hidden; }
//         .pdf-modal-body iframe { width: 100%; height: 100%; border: none; }
//         .empty-state { text-align: center; padding: 80px 20px; }
//         .empty-icon { font-size: 64px; margin-bottom: 16px; opacity: 0.3; display: block; }
//         .ebook-col { animation: slideUp 0.4s ease both; }
//         @keyframes slideUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
//       `}</style>

//       <div className="ebooks-root">
//         <div className="container">

//           {/* Header */}
//           <div className="text-center mb-5">
//             <h1 className="ebooks-title">E-Books</h1>
//           </div>

//           {/* Grid */}
//           <div className="row g-4">

//             {/* Loading skeletons */}
//             {loading && [1,2,3,4,5,6].map((n) => (
//               <div className="col-12 col-sm-6 col-md-4" key={n}>
//                 <div style={{ borderRadius: 18, overflow: "hidden", border: "1px solid #e8e5dc", background: "#fff" }}>
//                   <div className="skeleton" style={{ height: 230 }} />
//                   <div style={{ padding: "18px" }}>
//                     <div className="skeleton" style={{ height: 20, marginBottom: 10, borderRadius: 6 }} />
//                     <div className="skeleton" style={{ height: 14, marginBottom: 6, borderRadius: 6, width: "80%" }} />
//                     <div className="skeleton" style={{ height: 14, borderRadius: 6, width: "60%" }} />
//                     <div className="skeleton" style={{ height: 44, marginTop: 20, borderRadius: 11 }} />
//                   </div>
//                 </div>
//               </div>
//             ))}

//             {/* Book cards */}
//             {!loading && pdfs.map((item, idx) => {
//               const strProdId  = String(item.prod_id);
//               const isPurchased = purchasedProdIds.has(strProdId);
//               const isAdded    = addedItems.includes(strProdId);
//               const isItemLoading = loadingItem === item.prod_id;
//               const hasPrice   = item.current_price && Number(item.current_price) > 0;
//               const hasOldPrice = item.old_price && Number(item.old_price) > 0;
//               const cleanDesc  = stripHtml(item.description);

//               return (
//                 <div
//                   className="col-12 col-sm-6 col-md-4 ebook-col"
//                   key={item.prod_id}
//                   style={{ animationDelay: `${idx * 60}ms` }}
//                 >
//                   <div className="ebook-card">

//                     {/* Purchased / Locked badge */}
//                     {item.prod_id && (
//                       <div className={`ebook-badge${isPurchased ? "" : " locked-badge"}`}>
//                         {isPurchased
//                           ? <><UnlockIcon /> Purchased</>
//                           : <><LockIcon /> <span style={{ fontSize: 10 }}>Locked</span></>
//                         }
//                       </div>
//                     )}

//                     {/* Cover — click goes to detail page using prod_id */}
//                     <div
//                       className={`ebook-cover${isPurchased ? "" : " locked"}`}
//                       onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
//                     >
//                       {item.pdf ? (
//                         <iframe
//                           src={`${BASE_URL}/${item.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
//                           title={item.name}
//                         />
//                       ) : (
//                         <div style={{
//                           width: "100%", height: "100%",
//                           display: "flex", alignItems: "center", justifyContent: "center",
//                           color: "#ccc", fontSize: 40,
//                         }}>📖</div>
//                       )}

//                       {!isPurchased && (
//                         <div className="lock-overlay">
//                           <LockIcon />
//                           <span>Purchase to Access</span>
//                         </div>
//                       )}
//                     </div>

//                     {/* Body */}
//                     <div className="ebook-body">

//                       {/* Title — click navigates to detail using prod_id */}
//                       <h6
//                         className="ebook-name"
//                         onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
//                         title={item.name}
//                       >
//                         {item.name}
//                       </h6>

//                       {/* Description */}
//                       <p className="ebook-desc" title={cleanDesc}>
//                         {cleanDesc || "\u00A0"}
//                       </p>

//                       <hr className="ebook-divider" />

//                       {/* Price */}
//                       <div className="ebook-price-row">
//                         {hasPrice ? (
//                           <>
//                             <span className="price-current">
//                               ₹{Number(item.current_price).toLocaleString()}
//                             </span>
//                             {hasOldPrice && (
//                               <span className="price-old">
//                                 ₹{Number(item.old_price).toLocaleString()}
//                               </span>
//                             )}
//                           </>
//                         ) : (
//                           <span className="price-na">Price not available</span>
//                         )}
//                       </div>

//                       {/* CTA */}
//                       {/* {isPurchased ? (
//                         <button
//                           className="btn-open-pdf"
//                           onClick={() => handleOpenPdf(item)}
//                         >
//                           <BookIcon /> Open PDF
//                         </button>
//                       ) : (
//                         <button
//                           className={`btn-add-cart${isAdded ? " added" : ""}${!item.prod_id ? " unavailable" : ""}`}
//                           onClick={() => !isAdded && !isItemLoading && handleAddToCart(item.prod_id)}
//                           disabled={isItemLoading}
//                         >
//                           {isItemLoading ? (
//                             <span className="spinner-border spinner-border-sm" role="status" />
//                           ) : isAdded ? (
//                             <>Added ✓</>
//                           ) : !item.prod_id ? (
//                             <>Unavailable</>
//                           ) : (
//                             <><CartIcon /> Add to Cart</>
//                           )}
//                         </button>
//                       )} */}
//                       {isPurchased ? (
//   <button
//     className="btn-open-pdf"
//     onClick={() => handleOpenPdf(item)}
//   >
//     <BookIcon /> Open PDF
//   </button>
// ) : (
//   <div className="ebook-action-row">
//     <button
//       className={`btn-add-cart${isAdded ? " added" : ""}${!item.prod_id ? " unavailable" : ""}`}
//       onClick={() => !isAdded && !isItemLoading && handleAddToCart(item)}
//       disabled={isItemLoading || !item.prod_id}
//     >
//       {isItemLoading ? (
//         <span className="spinner-border spinner-border-sm" role="status" />
//       ) : isAdded ? (
//         <>Added ✓</>
//       ) : !item.prod_id ? (
//         <>Unavailable</>
//       ) : (
//         <><CartIcon /> Add to Cart</>
//       )}
//     </button>

//     <button
//       className="btn-buy-now"
//       onClick={() => !isItemLoading && handleBuyNow(item)}
//       disabled={isItemLoading || !item.prod_id}
//     >
//       Buy Now
//     </button>
//   </div>
// )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}

//             {/* Empty state */}
//             {!loading && pdfs.length === 0 && (
//               <div className="col-12">
//                 <div className="empty-state">
//                   <span className="empty-icon">📚</span>
//                   <h5 style={{ color: "#888", fontWeight: 600 }}>No E-Books available yet</h5>
//                   <p style={{ color: "#bbb", fontSize: 14 }}>Check back soon for new books!</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* PDF Viewer Modal */}
//       {openPdfId && activePdf && (
//         <div className="pdf-modal-overlay" onClick={() => setOpenPdfId(null)}>
//           <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="pdf-modal-header">
//               <p className="pdf-modal-title">{activePdf.name}</p>
//               <button className="pdf-modal-close" onClick={() => setOpenPdfId(null)}>×</button>
//             </div>
//             <div className="pdf-modal-body">
//               <iframe
//                 src={`${BASE_URL}/${activePdf.pdf}#toolbar=1&navpanes=0`}
//                 title={activePdf.name}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       <FooterNew />
//     </>
//   );
// };

// export default Ebooks;

// On 20 march 
import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../../Context/CartContext";
import SEO from "../../SEO";

const BASE_URL = "https://ecom.cyberathon.com";

// ── Guest cart token (same as ProductsAPI2 & CourseSection2) ─────────────────
const getCartToken = () => {
  let token = localStorage.getItem("cart_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("cart_token", token);
  }
  return token;
};

// ── Strip HTML tags ───────────────────────────────────────────────────────────
const stripHtml = (html) => {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

// ── Icons ─────────────────────────────────────────────────────────────────────
const LockIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);
const UnlockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
  </svg>
);
const BookIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
);
const CartIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
  </svg>
);
const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

// ── Normalize ebook ───────────────────────────────────────────────────────────
const normalizeEbook = (item) => ({
  prod_id:       item.prod_id,
  name:          item.name || item.Product_name || "Untitled Book",
  description:   item.description || "",
  details:       item.details || "",
  pdf:           item.pdf || "",
  current_price: item.current_price || 0,
  old_price:     item.old_price || 0,
});

// ── Add to Cart API (guest + logged-in) ───────────────────────────────────────
async function addToCartApi(prod_id, onSuccess, onError) {
  const userId    = sessionStorage.getItem("userId");
  const cartToken = !userId ? getCartToken() : null;

  if (!userId) {
    // Guest: try inserting with cart_token
    try {
      const listRes = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
        user_id: null, cart_token: cartToken,
      });
      if (listRes.data.status) {
        const exists = listRes.data.cart_items.find(
          (i) => String(i.prod_id) === String(prod_id)
        );
        if (exists) { onSuccess(); return; }
      }
      const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
        user_id: null, prod_id: Number(prod_id), qty: 1, cart_token: cartToken,
      });
      if (res.data.status === true) {
        onSuccess();
      } else {
        // Guest cart not supported by backend → open login
        sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
        window.dispatchEvent(new Event("openLoginModal"));
      }
    } catch (e) {
      console.error(e);
      sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      window.dispatchEvent(new Event("openLoginModal"));
    }
    return;
  }

  // Logged-in user
  try {
    const listRes = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
      user_id: userId, cart_token: null,
    });
    if (listRes.data.status) {
      const exists = listRes.data.cart_items.find(
        (i) => String(i.prod_id) === String(prod_id)
      );
      if (exists) { onSuccess(); return; }
    }
    const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
      user_id: Number(userId), prod_id: Number(prod_id), qty: 1,
    });
    if (res.data.status === true) onSuccess();
    else onError(res.data.message || "Failed to add");
  } catch (e) {
    console.error(e);
    onError("Something went wrong");
  }
}

// ── Buy Now API (add to cart → redirect to /Bill) ────────────────────────────
// async function buyNowApi(prod_id, navigate, onError, setLoading) {
//   const userId    = sessionStorage.getItem("userId");
//   const cartToken = !userId ? getCartToken() : null;

//   if (!prod_id) { onError("This item is not available."); return; }

//   if (!userId) {
//     // Guest: save intent then open login
//     sessionStorage.setItem("redirectAfterLogin", "/Bill");
//     sessionStorage.setItem("buyNowProdId", String(prod_id));
//     window.dispatchEvent(new Event("openLoginModal"));
//     setLoading(null);
//     return;
//   }

//   try {
//     const listRes = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//       user_id: userId, cart_token: null,
//     });
//     let cartItem = null;
//     if (listRes.data.status) {
//       cartItem = listRes.data.cart_items.find(
//         (i) => String(i.prod_id) === String(prod_id)
//       );
//     }

//     if (cartItem) {
//       // Already in cart → go to billing directly
//       navigate("/Bill");
//     } else {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId), prod_id: Number(prod_id), qty: 1,
//       });
//       if (res.data.status === true) navigate("/Bill");
//       else onError(res.data.message || "Failed to add. Please try again.");
//     }
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   } finally {
//     setLoading(null);
//   }
// }
// ── Buy Now (no cart insert, direct navigate with product data) ──────────────
async function buyNowApi(item, navigate, onError, setLoading) {
  const userId = sessionStorage.getItem("userId");

  if (!item?.prod_id) {
    onError("This item is not available.");
    return;
  }

  const buyNowProduct = {
    prod_id: item.prod_id,
    Product_name: item.name,
    current_price: item.current_price,
    qty: 1,
    size: "",
    Product_image: item.pdf || "",
    product_type:"ebook",
  };

  // 🔴 Not logged in
  if (!userId) {

    // product save karo
    sessionStorage.setItem(
      "buyNowProduct",
      JSON.stringify(buyNowProduct)
    );

    // redirect save karo
    sessionStorage.setItem(
      "redirectAfterLogin",
      "/Bill"
    );

    // login modal open karo
    window.dispatchEvent(
      new Event("openLoginModal")
    );

    setLoading(null);
    return;
  }

  // 🟢 Logged in
  navigate("/Bill", {
    state: {
      buyNow: true,
      product: buyNowProduct
    }
  });

  setLoading(null);
}

// ── Main Component ────────────────────────────────────────────────────────────
const Ebooks = () => {
  const navigate = useNavigate();
  const { setCartCount } = useCart();

  const [pdfs, setPdfs]                         = useState([]);
  const [addedItems, setAddedItems]             = useState([]);   // prod_id strings
  const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
  const [loadingItem, setLoadingItem]           = useState(null); // prod_id of item in progress
  const [buyLoadingItem, setBuyLoadingItem]     = useState(null);
  const [loading, setLoading]                   = useState(true);
  const [openPdfId, setOpenPdfId]               = useState(null);
const [seoData, setSeoData] = useState({});
  // ── Fetch ebooks ────────────────────────────────────────────────────────────
  useEffect(() => {
    axios
      .get(`${BASE_URL}/index.php/Api/list_get_product`)
      .then((res) => {
        if (res.data?.status && Array.isArray(res.data.products)) {
          const ebooksOnly = res.data.products
            .filter((item) => item.product_type?.toLowerCase() === "ebook")
            .map(normalizeEbook);
          setPdfs(ebooksOnly);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);
useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/index.php/Api/get_seo_by_page`, {
        page_name: 'ebooks'   // <-- Important! page_name 'ebooks' rakho
      });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  // ── Fetch cart + purchased (guest & logged-in) ──────────────────────────────
  useEffect(() => {
    const init = async () => {
      const userId    = sessionStorage.getItem("userId");
      // Guest cart_token se bhi cart load karo
      const cartToken = localStorage.getItem("cart_token");

      if (userId || cartToken) {
        try {
          const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
            user_id:    userId || null,
            cart_token: userId ? null : cartToken,
          });
          if (res.data.status) {
            const ids = res.data.cart_items.map((i) => String(i.prod_id));
            setAddedItems(ids);
          }
        } catch (err) { console.error("Cart load error:", err); }
      }

      if (userId) {
        try {
          const res = await axios.post(`${BASE_URL}/index.php/Api/list_new_order`, {
            user_id: parseInt(userId),
          });
          if (res.data.status && Array.isArray(res.data.orders)) {
            const purchasedIds = new Set();
            res.data.orders.forEach((order) => {
              if (!Array.isArray(order.items)) return;
              order.items.forEach((item) => {
                if (!item.prod_id) return;
                if (
                  item.access === "unlocked" ||
                  order.purchase_status === "yes" ||
                  order.payment_status === "Paid" ||
                  order.payment_status === "paid" ||
                  order.order_status === "Delivered" ||
                  order.order_status === "Completed"
                ) {
                  purchasedIds.add(String(item.prod_id));
                }
              });
            });
            setPurchasedProdIds(purchasedIds);
          }
        } catch (err) { console.error("Orders load error:", err); }
      }
    };

    init();

    // Re-init when user logs in (so cart_token items show as added)
    const onLogin = () => init();
    window.addEventListener("userLoggedIn", onLogin);
    return () => window.removeEventListener("userLoggedIn", onLogin);
  }, []);

  // ── Add to Cart ─────────────────────────────────────────────────────────────
  const handleAddToCart = (item) => {
    if (!item?.prod_id || loadingItem === item.prod_id) return;
    const strId = String(item.prod_id);
    if (addedItems.includes(strId)) return;

    setLoadingItem(item.prod_id);

    addToCartApi(
      item.prod_id,
      () => {
        setAddedItems((prev) => [...prev, strId]);
        setCartCount((prev) => prev + 1);
        setLoadingItem(null);
      },
      (msg) => {
        alert(msg);
        setLoadingItem(null);
      }
    );
  };

  // ── Buy Now ─────────────────────────────────────────────────────────────────
  // const handleBuyNow = (item) => {
  //   if (!item?.prod_id || buyLoadingItem === item.prod_id) return;
  //   setBuyLoadingItem(item.prod_id);
  //   buyNowApi(
  //     item.prod_id,
  //     navigate,
  //     (msg) => { alert(msg); setBuyLoadingItem(null); },
  //     setBuyLoadingItem
  //   );
  // };
const handleBuyNow = (item) => {
  if (!item?.prod_id || buyLoadingItem === item.prod_id) return;
  setBuyLoadingItem(item.prod_id);
  buyNowApi(
    item,        // ← pehle sirf prod_id tha, ab poora item
    navigate,
    (msg) => { alert(msg); setBuyLoadingItem(null); },
    setBuyLoadingItem
  );
};
  // ── Open PDF modal ──────────────────────────────────────────────────────────
  const handleOpenPdf = (item) => setOpenPdfId(item.prod_id);
  const activePdf = pdfs.find((p) => String(p.prod_id) === String(openPdfId));

  return (
    <>
    <SEO
    title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
    description={seoData.description || "Explore our wide collection of E-Books on programming, design, and more."}
    keywords={seoData.keywords || "ebooks, shopindia, buy ebooks, online books, programming ebooks, design ebooks"}
    canonical={seoData.canonical || "https://www.shopindia.com/ebooks"}
  />
      <Layout />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

        .ebooks-root {
          background: #f5f4f0; min-height: 100vh;
          font-family: 'DM Sans', sans-serif; padding: 48px 0 80px;
        }
        .ebooks-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(2rem, 4vw, 2.8rem); font-weight: 800;
          color: #1c1a14; letter-spacing: -0.5px; margin-bottom: 6px;
        }
        .ebook-card {
          background: #fff; border-radius: 18px; overflow: hidden;
          border: 1px solid #e8e5dc; display: flex; flex-direction: column;
          height: 100%; transition: transform 0.25s ease, box-shadow 0.25s ease;
          position: relative;
        }
        .ebook-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.10);
        }
        .ebook-cover {
          position: relative; width: 100%; height: 230px;
          background: #f0ece0; overflow: hidden; cursor: pointer;
        }
        .ebook-cover iframe { width: 100%; height: 100%; border: none; pointer-events: none; }
        .ebook-cover.locked iframe { filter: blur(3px); opacity: 0.6; }
        .lock-overlay {
          position: absolute; inset: 0;
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          background: rgba(28,26,20,0.45); gap: 8px; color: #fff;
        }
        .lock-overlay span {
          font-size: 12px; font-weight: 600; letter-spacing: 0.5px;
          text-transform: uppercase; opacity: 0.9;
        }
        .ebook-badge {
          position: absolute; top: 12px; right: 12px;
          background: #27ae60; color: #fff; font-size: 10.5px;
          font-weight: 700; padding: 3px 9px; border-radius: 20px;
          text-transform: uppercase; letter-spacing: 0.5px;
          display: flex; align-items: center; gap: 4px; z-index: 2;
        }
        .ebook-badge.locked-badge { background: #b0a898; }

        .ebook-body {
          padding: 18px 18px 20px; display: flex;
          flex-direction: column; flex: 1; gap: 10px;
        }
        .ebook-name {
          font-family: 'Playfair Display', serif; font-size: 16px;
          font-weight: 700; color: #1c1a14; margin: 0;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
          cursor: pointer;
        }
        .ebook-name:hover { color: #24aeb1; }
        .ebook-desc {
          font-size: 13px; color: #888; margin: 0;
          display: -webkit-box; -webkit-line-clamp: 2;
          -webkit-box-orient: vertical; overflow: hidden;
          line-height: 1.65; min-height: 43px;
        }
        .ebook-divider { border: none; border-top: 1px solid #f0ece0; margin: 2px 0; }
        .ebook-price-row { display: flex; align-items: baseline; gap: 10px; }
        .price-current { font-size: 20px; font-weight: 800; color: #27ae60; font-family: 'DM Sans', sans-serif; }
        .price-old { font-size: 13px; color: #bbb; text-decoration: line-through; }
        .price-na { font-size: 13px; color: #bbb; font-style: italic; }
        .price-free { font-size: 18px; font-weight: 800; color: #24aeb1; font-family: 'DM Sans', sans-serif; }

        /* ── CTA Buttons ── */
        .btn-open-pdf {
          display: flex; align-items: center; justify-content: center; gap: 8px;
          padding: 11px 0; border-radius: 11px; border: none;
          font-size: 14px; font-weight: 700; cursor: pointer;
          background: linear-gradient(135deg, #27ae60, #1e8449);
          color: #fff; width: 100%; letter-spacing: 0.3px;
          transition: opacity 0.2s; margin-top: auto;
        }
        .btn-open-pdf:hover { opacity: 0.88; }

        /* Add to Cart + Buy Now side by side */
        .ebook-action-row {
          display: grid; grid-template-columns: 1fr 1fr;
          gap: 8px; margin-top: auto;
        }
        .btn-add-cart {
          display: flex; align-items: center; justify-content: center; gap: 7px;
          padding: 11px 0; border-radius: 11px;
          border: 1.5px solid #24aeb1;
          font-size: 13.5px; font-weight: 700; cursor: pointer;
          background: linear-gradient(135deg, #24aeb1, #058587); color:white;
          width: 100%; letter-spacing: 0.2px;
          transition: background 0.2s, color 0.2s, transform 0.15s;
          user-select: none;
        }
        .btn-add-cart:hover:not(.added):not(.unavailable):not(:disabled) {
          background: #24aeb1; color: #fff; transform: translateY(-1px);
        }
        .btn-add-cart.added {
          background:linear-gradient(135deg, #24aeb1, #058587); border-color: #24aeb1;
          color: white; cursor: default;
        }
        .btn-add-cart.unavailable { background: #f0ece0; border-color: #e0ddd4; color: #bbb; cursor: default; }
        .btn-add-cart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

        .btn-buy-now {
          display: flex; align-items: center; justify-content: center; gap: 7px;
          padding: 11px 0; border-radius: 11px; border: none;
          font-size: 13.5px; font-weight: 700; cursor: pointer;
          background: linear-gradient(135deg, #24aeb1, #058587);
          color: #fff; width: 100%; letter-spacing: 0.2px;
          transition: opacity 0.2s, transform 0.15s;
          box-shadow: 0 2px 10px rgba(9, 190, 193, 0.28);
        }
        .btn-buy-now:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
        .btn-buy-now:disabled { opacity: 0.65; cursor: not-allowed; }

        /* Spinner */
        .eb-spinner {
          display: inline-block; width: 14px; height: 14px;
          border: 2px solid rgba(255,255,255,0.3); border-top-color: currentColor;
          border-radius: 50%; animation: ebSpin 0.7s linear infinite;
        }
        @keyframes ebSpin { to { transform: rotate(360deg); } }

        /* Skeleton */
        .skeleton {
          background: linear-gradient(90deg, #f0ece0 25%, #e8e5dc 50%, #f0ece0 75%);
          background-size: 200% 100%; animation: shimmer 1.4s infinite; border-radius: 10px;
        }
        @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

        /* PDF Modal */
        .pdf-modal-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,0.75);
          z-index: 9999; display: flex; align-items: center; justify-content: center;
          padding: 20px; animation: fadeIn 0.2s ease;
        }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .pdf-modal {
          background: #1c1a14; border-radius: 16px; width: 100%; max-width: 900px;
          height: 90vh; display: flex; flex-direction: column; overflow: hidden;
          box-shadow: 0 40px 80px rgba(0,0,0,0.5);
        }
        .pdf-modal-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 16px 22px; background: #272520; border-bottom: 1px solid #3a3730;
        }
        .pdf-modal-title {
          font-family: 'Playfair Display', serif; font-size: 16px; color: #f5f4f0;
          margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 70%;
        }
        .pdf-modal-close {
          background: #3a3730; border: none; color: #ccc;
          width: 34px; height: 34px; border-radius: 8px; font-size: 20px;
          cursor: pointer; display: flex; align-items: center; justify-content: center;
          transition: background 0.2s;
        }
        .pdf-modal-close:hover { background: #e74c3c; color: #fff; }
        .pdf-modal-body { flex: 1; overflow: hidden; }
        .pdf-modal-body iframe { width: 100%; height: 100%; border: none; }

        .empty-state { text-align: center; padding: 80px 20px; }
        .empty-icon { font-size: 64px; margin-bottom: 16px; opacity: 0.3; display: block; }
        .ebook-col { animation: slideUp 0.4s ease both; }
        @keyframes slideUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }

        @media (max-width: 480px) {
          .ebook-action-row { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="ebooks-root">
        <div className="container">

          {/* Header */}
          <div className="text-center mb-5">
            <h1 className="ebooks-title">E-Books</h1>
          </div>

          {/* Grid */}
          <div className="row g-4">

            {/* Loading skeletons */}
            {loading && [1,2,3,4,5,6].map((n) => (
              <div className="col-12 col-sm-6 col-md-4" key={n}>
                <div style={{ borderRadius: 18, overflow: "hidden", border: "1px solid #e8e5dc", background: "#fff" }}>
                  <div className="skeleton" style={{ height: 230 }} />
                  <div style={{ padding: "18px" }}>
                    <div className="skeleton" style={{ height: 20, marginBottom: 10, borderRadius: 6 }} />
                    <div className="skeleton" style={{ height: 14, marginBottom: 6, borderRadius: 6, width: "80%" }} />
                    <div className="skeleton" style={{ height: 14, borderRadius: 6, width: "60%" }} />
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 20 }}>
                      <div className="skeleton" style={{ height: 44, borderRadius: 11 }} />
                      <div className="skeleton" style={{ height: 44, borderRadius: 11 }} />
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Ebook cards */}
            {!loading && pdfs.map((item, idx) => {
              const strProdId     = String(item.prod_id);
              const isPurchased   = purchasedProdIds.has(strProdId);
              const isAdded       = addedItems.includes(strProdId);
              const isCartLoading = loadingItem === item.prod_id;
              const isBuyLoading  = buyLoadingItem === item.prod_id;
              const hasPrice      = item.current_price && Number(item.current_price) > 0;
              const hasOldPrice   = item.old_price && Number(item.old_price) > 0;
              const cleanDesc     = stripHtml(item.description);

              return (
                <div
                  className="col-12 col-sm-6 col-md-4 ebook-col"
                  key={item.prod_id}
                  style={{ animationDelay: `${idx * 60}ms` }}
                >
                  <div className="ebook-card">

                    {/* Badge */}
                    {item.prod_id && (
                      <div className={`ebook-badge${isPurchased ? "" : " locked-badge"}`}>
                        {isPurchased
                          ? <><UnlockIcon /> Purchased</>
                          : <><LockIcon /><span style={{ fontSize: 10 }}>Locked</span></>
                        }
                      </div>
                    )}

                    {/* Cover */}
                    <div
                      className={`ebook-cover${isPurchased ? "" : " locked"}`}
                      onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
                    >
                      {item.pdf ? (
                        <iframe
                          src={`${BASE_URL}/${item.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
                          title={item.name}
                        />
                      ) : (
                        <div style={{
                          width: "100%", height: "100%",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          color: "#ccc", fontSize: 40,
                        }}>📖</div>
                      )}
                      {!isPurchased && (
                        <div className="lock-overlay">
                          <LockIcon />
                          <span>Purchase to Access</span>
                        </div>
                      )}
                    </div>

                    {/* Body */}
                    <div className="ebook-body">

                      {/* Title */}
                      <h6
                        className="ebook-name"
                        onClick={() => navigate(`/EbookDetail/${item.prod_id}`)}
                        title={item.name}
                      >
                        {item.name}
                      </h6>

                      {/* Description */}
                      <p className="ebook-desc" title={cleanDesc}>
                        {cleanDesc || "\u00A0"}
                      </p>

                      <hr className="ebook-divider" />

                      {/* Price */}
                      <div className="ebook-price-row">
                        {hasPrice ? (
                          <>
                            <span className="price-current">
                              ₹{Number(item.current_price).toLocaleString("en-IN")}
                            </span>
                            {hasOldPrice && (
                              <span className="price-old">
                                ₹{Number(item.old_price).toLocaleString("en-IN")}
                              </span>
                            )}
                          </>
                        ) : (
                          <span className="price-free">Free</span>
                        )}
                      </div>

                      {/* CTA */}
                      {isPurchased ? (
                        // Purchased → Open PDF
                        <button
                          className="btn-open-pdf"
                          onClick={() => handleOpenPdf(item)}
                        >
                          <BookIcon /> Open PDF
                        </button>
                      ) : !item.prod_id ? (
                        // No prod_id → unavailable
                        <div className="ebook-action-row">
                          <button className="btn-add-cart unavailable" disabled>
                            Unavailable
                          </button>
                        </div>
                      ) : (
                        // Normal → Add to Cart + Buy Now
                        <div className="ebook-action-row">

                          {/* Add to Cart */}
                          <button
                            className={`btn-add-cart${isAdded ? " added" : ""}`}
                            onClick={() => handleAddToCart(item)}
                            disabled={isCartLoading || isAdded}
                          >
                            {isCartLoading ? (
                              <span className="eb-spinner" />
                            ) : isAdded ? (
                              <><CheckIcon /> Added</>
                            ) : (
                              <><CartIcon /> Add to Cart</>
                            )}
                          </button>

                          {/* Buy Now */}
                          <button
                            className="btn-buy-now"
                            onClick={() => handleBuyNow(item)}
                            disabled={isBuyLoading}
                          >
                            {isBuyLoading
                              ? <span className="eb-spinner" style={{ borderTopColor: "#fff" }} />
                              : "Buy Now"
                            }
                          </button>

                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Empty state */}
            {!loading && pdfs.length === 0 && (
              <div className="col-12">
                <div className="empty-state">
                  <span className="empty-icon">📚</span>
                  <h5 style={{ color: "#888", fontWeight: 600 }}>No E-Books available yet</h5>
                  <p style={{ color: "#bbb", fontSize: 14 }}>Check back soon for new books!</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* PDF Viewer Modal */}
      {openPdfId && activePdf && (
        <div className="pdf-modal-overlay" onClick={() => setOpenPdfId(null)}>
          <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pdf-modal-header">
              <p className="pdf-modal-title">{activePdf.name}</p>
              <button className="pdf-modal-close" onClick={() => setOpenPdfId(null)}>×</button>
            </div>
            <div className="pdf-modal-body">
              <iframe
                src={`${BASE_URL}/${activePdf.pdf}#toolbar=1&navpanes=0`}
                title={activePdf.name}
              />
            </div>
          </div>
        </div>
      )}

      <FooterNew />
    </>
  );
};

export default Ebooks;